module.exports = __webpack_public_path__ + "static/stencil-page1-72dpi-e89ca4163fdf2152951708c17a3bcedf.png";